import { Outlet, Navigate, useNavigate } from "react-router-dom";
import { useContext, useEffect } from "react";
import jwt_decode from "jwt-decode";

//Global State using JOTAI
import { useAtom } from "jotai";
import { gbState } from "../../components/shared/GlobalState";

// Define all possible roles in the system
export const ROLES = {
  FULL_ACCESS: "FULL_ACCESS",
  CHURCH_ADMIN: "CHURCH_ADMIN",
  CHURCH_MEMBER: "CHURCH_MEMBER",
  EMPLOYEE: "EMPLOYEE",
  SUB_MEMBER: "SUB_MEMBER",
};

const PrivateRoutes = (props) => {
  const navigate = useNavigate();
  const [{ errorLogApi, user }] = useAtom(gbState);

  // Get token and decode user details
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  let userDetails;
  try {
    userDetails = jwt_decode(token);
  } catch (error) {
    console.error("Invalid token:", error);
    localStorage.removeItem("token");
    return <Navigate to="/login" replace />;
  }

  const currentUserRole = userDetails?.role;

  // If no role is found, clear token and redirect to login
  if (!currentUserRole) {
    localStorage.removeItem("token");
    return <Navigate to="/login" replace />;
  }

  // If specific roles are required, check if user has permission
  if (props.roleRequired && props.roleRequired.length > 0) {
    const hasRequiredRole = props.roleRequired.includes(currentUserRole);
    console.log(currentUserRole)
    if (!hasRequiredRole) {
      return <Navigate to="/error403" replace />;
    }
  }

  // User has required role, render the protected route
  return <Outlet />;
};

// Default to allowing all authenticated roles if none specified
PrivateRoutes.defaultProps = {
  roleRequired: Object.values(ROLES),
};

export default PrivateRoutes;
